import LogServiceForm from '../LogServiceForm';
import { useState } from 'react';

import { Overlay } from '@american-autonomy/ag-ui';

import Modal from 'components/Modal';

import useServiceLog from 'hooks/useServiceLog';

import { TEST_ID } from './constants';
import type { FunctionComponent, HandleSubmit, Props } from './types';

import styles from './styles.module.scss';

const LogServiceModal: FunctionComponent<Props> = ({
    assetId,
    className = '',
    onClose,
    onSaved,
    testId = TEST_ID
}) => {
    const { createServiceLog, isLoading } = useServiceLog();

    const [isRequestingClose, setIsRequestingClose] = useState(false);

    const handleRequestClose = () => setIsRequestingClose(true);

    const handleCancelClose = () => setIsRequestingClose(false);

    const handleClose = () => {
        setIsRequestingClose(false);
        onClose();
    };

    const handleSubmit: HandleSubmit = async serviceLog => {
        const created = await createServiceLog({ assetId, serviceLog });

        if (!created) {
            return;
        }

        handleClose();
        onSaved();
    };

    const confirmingClass = isRequestingClose ? styles.confirming : '';

    return (
        <Overlay
            className={`${className} ${styles.logServiceModal}`}
            onClose={handleRequestClose}
            testId={testId}>
            <Modal className={`${styles.modal} ${confirmingClass}`}>
                <LogServiceForm
                    assetId={assetId}
                    isSaving={isLoading}
                    onCancelClose={handleCancelClose}
                    onClose={handleClose}
                    onRequestClose={handleRequestClose}
                    onSubmit={handleSubmit}
                    requestingClose={isRequestingClose}
                />
            </Modal>
        </Overlay>
    );
};

export default LogServiceModal;
